import styled from "styled-components";
import { Input } from "@material-ui/core";

export default styled(Input)`
  margin-top: 12px;
  font-size: 16px;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
`;
